module.exports = __webpack_public_path__ + "assets/img/recommend_icon03.5d51c429.png";